import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import CancelIcon from "@mui/icons-material/Close";
import "./style.css";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import {
  Button,
  Grid,
  DialogActions,
  DialogContent,
  TextField,
} from "@mui/material";
import {
  createFolder,
  inputFolderValue,
  inputUploadFolderId,
  displayFolderList,
  displayFolderListSuccess,
  displayFolderListError,
  openErrorDialog,
  scenarioaBack,
  createrFolderOrScenarioError,
  addProcessingPackagingPlantsDiff,
  addSourceBePartOfOptimization,
  addPackingPlantAddMinorIngredient,
  selectedFolderListSuccess,
} from "./../../../Redux/Actions/InputData";
import PlusIcon from "./../../../Assests/plus-icon.svg";
import {
  API_BASE_URL,
  LONG_CTREATE_GETALLFOLDERS_API,
  LONG_GETALLFOLDERS_API,
} from "../../../Utils/Config";
import { getRequest } from "../../../Services/AxiosConfiguration";

const BootstrapDialog = styled(Dialog)(({ theme }: any) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function FolderModal(props: any) {
  // localStorage.clear();

  const dispatch: any = useDispatch();
  const [selectFolder, setSelectFolder] = useState<any>({});
  const [folderOptions, setFolderOptions] = useState([]);
  const [newScenarioValue, setNewScenarioValue] = useState("");
  const [newFolderValue, setNewFolderValue] = useState("");
  const createrFolderOrScenarioErrorMsg = useSelector(
    (state: any) => state.InputDataReducers.createrFolderOrScenarioError
  );

  const getIsProcessingPackagingPlantsDiff = useSelector(
    (state: any) => state.InputDataReducers.isProcessingPackagingPlantsDiff
  );

  const getIsSourceBePartOfOptimization = useSelector(
    (state: any) => state.InputDataReducers.isSourceBePartOfOptimization
  );

  const getIsPackingPlantAddMinorIngredient = useSelector(
    (state: any) => state.InputDataReducers.isPackingPlantAddMinorIngredient
  );

  const userData = useSelector(
    (state: any) => state.InputDataReducers.apiUserData
  );
  console.log(userData, "userData");

  const [ModuleForUpload, setModuleForUpload] = useState<any>("");

  let MKey: any;
  useEffect(() => {
    if (
      getIsProcessingPackagingPlantsDiff &&
      getIsSourceBePartOfOptimization &&
      getIsPackingPlantAddMinorIngredient
    ) {
      setModuleForUpload("module1");
      MKey = "module1";
    } else if (
      getIsProcessingPackagingPlantsDiff &&
      !getIsSourceBePartOfOptimization &&
      getIsPackingPlantAddMinorIngredient
    ) {
      setModuleForUpload("module2");
      MKey = "module2";
    } else if (
      !getIsProcessingPackagingPlantsDiff &&
      getIsSourceBePartOfOptimization &&
      !getIsPackingPlantAddMinorIngredient
    ) {
      setModuleForUpload("module3");
      MKey = "module3";
    } else if (
      !getIsProcessingPackagingPlantsDiff &&
      !getIsSourceBePartOfOptimization &&
      !getIsPackingPlantAddMinorIngredient
    ) {
      setModuleForUpload("module4");
      MKey = "module4";
    } else if (
      getIsProcessingPackagingPlantsDiff &&
      getIsSourceBePartOfOptimization &&
      !getIsPackingPlantAddMinorIngredient
    ) {
      setModuleForUpload("module5");
      MKey = "module5";
    } else if (
      getIsProcessingPackagingPlantsDiff &&
      !getIsSourceBePartOfOptimization &&
      !getIsPackingPlantAddMinorIngredient
    ) {
      setModuleForUpload("module6");
      MKey = "module6";
    }
  }, [
    getIsProcessingPackagingPlantsDiff,
    getIsSourceBePartOfOptimization,
    getIsPackingPlantAddMinorIngredient,
  ]);

  useEffect(() => {
    callFolderFilterApi();
  }, []);

  const callFolderFilterApi = async () => {
    dispatch(displayFolderList());
    const urls = API_BASE_URL + LONG_CTREATE_GETALLFOLDERS_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };

    await getRequest(urls, { ModuleKey: MKey }, header)
      .then((response) => {
        if (response.status === 200 && response.data) {
          let responseArray = [];
          responseArray.push(response.data?.data);
          const sorted = response.data?.data.sort((a: any, b: any) =>
            a?.folder.localeCompare(b?.folder)
          );
          setFolderOptions(sorted);
          dispatch(displayFolderListSuccess(response.data?.data));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
        dispatch(displayFolderListError(error.message));
      });
  };

  const handleScenarioChange = (e: any) => {
    const { value } = e.target;
    if (value) {
      setNewScenarioValue(value);
    } else {
      setNewScenarioValue("");
    }
  };

  const handleFolderChange = (e: any) => {
    const { value } = e.target;
    if (value) {
      setNewFolderValue(value);
    } else {
      setNewFolderValue("");
    }
  };

  const handleChangeSelectFolder = (e: any) => {
    setSelectFolder(e.target.value);
    localStorage.setItem("selectedCGOFolderId", e.target.value.id);
    dispatch(selectedFolderListSuccess(e.target.value));
    //setSelectedFolderId(e.target.value.id);
    if (e.target.value.id !== undefined) {
      console.log(e.target.value.id, "folderIDDDDD");
      dispatch(inputUploadFolderId(e.target.value.id));
    }
  };

  const [isCreateNewFolder, setIsCreateNewFolder] = useState(false);
  const handleOpenCreateFolder = () => {
    dispatch(createFolder());
    setIsCreateNewFolder(true);
  };

  const handleGoBack = () => {
    if (isCreateNewFolder || Object.keys(selectFolder)?.length !== 0) {
      dispatch(createrFolderOrScenarioError(""));
      setSelectFolder("");
      setNewScenarioValue("");
      setIsCreateNewFolder(false);
      //   dispatch(addProcessingPackagingPlantsDiff(true))
      // dispatch(addSourceBePartOfOptimization(true))
      // dispatch(addPackingPlantAddMinorIngredient(true))
    } else {
      props.handleGoBack();
      // dispatch(addProcessingPackagingPlantsDiff(true))
      // dispatch(addSourceBePartOfOptimization(true))
      // dispatch(addPackingPlantAddMinorIngredient(true))
    }
  };

  const handleCreateFolder = () => {
    isCreateNewFolder
      ? props.handleCreateNewFolder({
          scenario: newScenarioValue,
          folder: ModuleForUpload + "_" + newFolderValue,
          ...props.inputCapacityModalData,
          isCreateNewFolder: isCreateNewFolder,
          createdBy: userData.userId,
        })
      : props.handleCreateNewFolder({
          scenario: newScenarioValue,
          folder_id: selectFolder?.id || 0,
          ...props.inputCapacityModalData,
          isCreateNewFolder: isCreateNewFolder,
          createdBy: userData.userId,
        });
  };

  return (
    <div>
      {" "}
      <div>
        <BootstrapDialog
          onClose={props.onClose}
          aria-labelledby="customized-dialog-title"
          open={props.isOpen}
        >
          <div className="modal-header">
            <Grid container spacing={1}>
              <Grid item xs={10} md={10} lg={10}>
                <h3>Nakshatra</h3>
                <p className="sub-title-text">Select the folder</p>
              </Grid>
              <Grid item xs={2} md={2} lg={2}>
                <CancelIcon className="cancel-icon" onClick={props.onClose} />
              </Grid>
            </Grid>
          </div>
          <>
            <DialogContent>
              <div className="input-data-pop">
                {isCreateNewFolder === true ? (
                  <>
                    <FormControl fullWidth style={{ marginTop: "15px" }}>
                      <label className="select-folder-dropdown">
                        <h3>
                          <b> Prefix : {ModuleForUpload} </b>
                        </h3>
                      </label>
                      <label className="select-folder-dropdown">
                        Create Folder*
                      </label>
                      <div> </div>

                      <TextField
                        id="create-folder"
                        required
                        label="createfolder"
                        variant="outlined"
                        onChange={handleFolderChange}
                      ></TextField>
                      <br />
                      <label className="select-folder-dropdown">
                        Create Scenario*
                      </label>

                      <TextField
                        id="create-scenario"
                        required
                        label="create scenario"
                        variant="outlined"
                        onChange={handleScenarioChange}
                      ></TextField>
                    </FormControl>
                    {createrFolderOrScenarioErrorMsg && (
                      <h2 style={{ color: "red", paddingLeft: "20px" }}>
                        {createrFolderOrScenarioErrorMsg}
                      </h2>
                    )}
                  </>
                ) : (
                  <>
                    <FormControl fullWidth>
                      <label className="select-folder-dropdown">
                        Select Folder*
                      </label>
                      <TextField
                        id="select-folder"
                        select
                        required
                        label="Select"
                        variant="outlined"
                        onChange={handleChangeSelectFolder}
                        InputLabelProps={{ shrink: true }}
                        value={selectFolder}
                        defaultValue={""}
                      >
                        {folderOptions?.map((d: any) => (
                          <MenuItem key={d.id} value={d}>
                            {d.folder}
                          </MenuItem>
                        ))}
                      </TextField>
                    </FormControl>
                    {Object.keys(selectFolder)?.length !== 0 && (
                      <FormControl fullWidth style={{ marginTop: "15px" }}>
                        <label className="select-folder-dropdown">
                          Create Scenario*
                        </label>
                        <TextField
                          id="create-scenario"
                          required
                          label="create scenario"
                          variant="outlined"
                          onChange={handleScenarioChange}
                        ></TextField>
                      </FormControl>
                    )}
                    {Object.keys(selectFolder)?.length === 0 && (
                      <>
                        <div>
                          <h2 className="hr-lines">
                            <span>Or</span>
                          </h2>
                        </div>
                        <div
                          className="create-new-folder"
                          onClick={handleOpenCreateFolder}
                        >
                          <img src={PlusIcon} alt="" />
                          <h2>Create a new Folder</h2>
                        </div>
                      </>
                    )}
                    {createrFolderOrScenarioErrorMsg && (
                      <h2 style={{ color: "red", paddingLeft: "20px" }}>
                        {createrFolderOrScenarioErrorMsg}
                      </h2>
                    )}
                  </>
                )}
              </div>
            </DialogContent>

            <DialogActions>
              <div className="modal-action">
                <Button
                  variant="outlined"
                  className="cancel"
                  onClick={handleGoBack}
                >
                  Go back
                </Button>
                {newScenarioValue && (newFolderValue || selectFolder) ? (
                  <Button
                    variant="contained"
                    className={
                      newScenarioValue && (newFolderValue || selectFolder)
                        ? "Next"
                        : "disabled-proc-btn"
                    }
                    onClick={handleCreateFolder}
                  >
                    Proceed
                  </Button>
                ) : (
                  <Button variant="contained" className="disabled-proc-btn">
                    Proceed
                  </Button>
                )}
              </div>
            </DialogActions>
          </>
        </BootstrapDialog>
      </div>
    </div>
  );
}

export default FolderModal;
